import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './styles/shared/icons.css';

import App from './App';
import LoadingSpinner from './utils/spinners/LoadingSpinner';

const MINIMUM_LOADING_TIME = 1000; // 1 second minimum loading time

const Root = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const startTime = Date.now();

    const handleLoad = () => {
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(0, MINIMUM_LOADING_TIME - elapsedTime);

      // Ensure the spinner shows for at least MINIMUM_LOADING_TIME
      setTimeout(() => {
        setIsLoading(false);
      }, remainingTime);
    };

    // Check if the document is already loaded
    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
    }

    return () => window.removeEventListener('load', handleLoad);
  }, []);

  return isLoading ? (
    <LoadingSpinner message="Preparing your experience..." />
  ) : (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<Root />);
